import { rejected, resolved } from 'store/createAction';
import keyBy from 'lodash/keyBy';
import { FETCH_CC } from './types';

const initialState = {
  data: {},
  contact: null,
  loading: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CC:
      return {
        ...state,
        loading: true,
      };
    case resolved(FETCH_CC):
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          ...keyBy(payload, 'hash'),
        },
      };
    default:
      return state;
  }
};
